import { render, staticRenderFns } from "./orderBill.vue?vue&type=template&id=6c265f7b&scoped=true"
import script from "./orderBill.vue?vue&type=script&lang=js"
export * from "./orderBill.vue?vue&type=script&lang=js"
import style0 from "./orderBill.vue?vue&type=style&index=0&id=6c265f7b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c265f7b",
  null
  
)

export default component.exports